import { render, staticRenderFns } from "./ViewGateConnection.vue?vue&type=template&id=79adfa90&"
import script from "./ViewGateConnection.vue?vue&type=script&lang=js&"
export * from "./ViewGateConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports